import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/ungdommer',
    name: 'Ungdommer',
    component: () => import('./views/Ungdommer.vue')
  },
  {
    path: '/ungdommer/ungdom/:id',
    name: 'Ungdom',
    props: true,
    component: () => import('./components/Ungdom.vue')
  },
  {
    path: '/ungdommer/ungdom/oppfolgingsplan/:id',
    name: 'Oppfolgingsplan',
    props: true,
    component: () => import('./components/oppfolgingsplan/UngdomOppfolgingsplaner.vue')
  }
]

export default routes
